import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

export type SurfaceProps = {
  className?: string;
  children: React.ReactNode;
} & VariantProps<typeof surfaceStyle>;

const surfaceStyle = cva(twMerge('border border-solid'), {
  variants: {
    padding: {
      none: 'px-0 py-0',
      default: 'px-6 py-5 lg:px-7 lg:py-5',
    },
    style: {
      transparent: 'bg-[#000000]/40',
      gradient: 'bg-[linear-gradient(135deg,_#2B2F31_0%,_#000_100%)]',
      default: 'bg-[#1B1D1E]',
    },
    outline: {
      none: 'border-transparent',
      default: 'border-[rgba(0,_0,_0,_1)]',
      green: 'border-[#54FAAA]',
      red: 'border-[#FB5656]',
      dash: 'border-dashed border-[#EDFF6D]',
    },
    rounded: {
      none: 'rounded-none',
      default: 'rounded-[8px]',
      medium: 'rounded-[16px]',
      large: 'rounded-[28px]',
    },
  },
  defaultVariants: {
    style: 'default',
    outline: 'default',
    padding: 'default',
    rounded: 'default',
  },
});

export const Surface = (props: SurfaceProps) => {
  const { className, style, outline, rounded, children } = props;
  const classNames = twMerge(
    surfaceStyle({ style, outline, rounded }),
    className
  );

  return <div className={classNames}>{children}</div>;
};
